export default "__VITE_PUBLIC_ASSET__04ac039a__"